console.log("faq")

const List = require('list.js')

let listNames = window.faqLists
let $searchField = $('#searchQuery')

listNames.forEach(listName => {

  let list = new List('list-'+listName, {
    searchClass: "searchQuery",
    valueNames: ['question', 'words'],
    listClass: 'panel-group',
    listContainer: 'div',
    fuzzySearch: {
      searchClass: "searchQuery",
      location: 0,
      distance: 100,
      threshold: 0.8,
      multiSearch: true
    }
  })

  let $section = $('#section-'+listName)
  let $sectionList = $section.find('.list')

  $searchField.on("keyup",function(){
      list.fuzzySearch($searchField.val())

      if($sectionList.children().length){
        $section.removeClass('hidden')
      } else {
        $section.addClass('hidden')
      }

  })

})


$('.list-groups a').click(function(e){
  e.preventDefault();
  let target = $(this).attr('href')
  $('html, body').animate({
      scrollTop: $(target).offset().top
  }, 500);
});
